var exports = {
  "k": "xcc377c0b--795f8a--container",
  "n": "xcc377c0b--795f8a--link",
};

module.exports = exports;
